import { DealCreationStatus } from '../interfaces/deal-creation.interfaces';

export const DEAL_CREATION_PUSHER_EVENTS = ['deal_creation_succeeded', 'deal_creation_failed'];

export const STATUS_ORDER: DealCreationStatus[] = ['accepted', 'processing', 'succeeded', 'failed'];
export const POLL_INTERVAL_MS = 20000;
